module.exports = __webpack_public_path__ + "media/images/wood-bill-c87e091a46f221576d89d52bd99351b9.jpg";